
















































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { fetchConfigAutorizaciones } from './fetchConfigAutorizaciones';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

@Component({ components: { DatePicker, FormFieldsContainer } })
export default class ComponenteForm extends Vue {
  @Prop({ default: () => ({}) }) data: any;

  @Prop({ default: [] }) listaOperaciones: any;

  listaUsuarios: any = [];

  @Prop({ default: false }) creacion: Boolean;
  @Prop({ default: false }) edicion: Boolean;
  @Prop({ default: false }) visualizacion: Boolean;

  /// CAMPOS ///
  userID = JSON.parse(localStorage.getItem('user')).id;
  usuario: any = '';
  operacion: any = '';
  observacion = '';
  nroOrden: any = 1;
  nroConfig: any = 0;
  indefinido = false;
  estados = ['ACTIVO', 'INACTIVO'];
  estadoSelected = 'ACTIVO';
  /// FIN CAMPOS ///

  loadingService = new LoadingService();
  $snotify: any;
  inactivo: boolean = false;
  mounted() {
    this.getComboPublicUsuarios();
    if (this.edicion || this.visualizacion) {
      let data = this.data[0];
      this.nroConfig = data.numeroconfig;
      this.nroOrden = data.numeroorden;
      this.observacion = data.autoobserva;
      this.operacion = data.configdescripcion;
      this.usuario = data.usuariocompleto;
      this.estadoSelected = data.estado;
      if (this.estadoSelected == 'INACTIVO') {
        this.inactivo = true;
      }
      /* this.fechaInicio = moment(data.autofecha_inicio);
      if (data.autofecha_fin) this.fechaFin = moment(data.autofecha_fin);
      else {
        this.fechaFin = undefined;
        this.indefinido = true;
      } */
    }
  }

  getComboPublicUsuarios() {
    this.loadingService.showLoading(undefined, 'getComboPublicUsuarios');
    fetchConfigAutorizaciones('getComboPublicUsuarios', {})
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.listaUsuarios = data.data.data;
        } else this.listaUsuarios = [];
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getComboPublicUsuarios'));
  }

  emitirParaGuardar() {
    let obj = {
      userID: this.userID ? this.userID : null,
      usuarioSeleccionado: this.usuario.id ? this.usuario.id : null,
      operacion: this.operacion.configid ? this.operacion.configid : null,
      observacion: this.observacion ? this.observacion : null,
      numeroOrden: this.nroOrden ? this.nroOrden : 1,
      numeroConfig: this.nroConfig ? this.nroConfig : null,
      estado: this.estadoSelected,
    };
    if (this.creacion) this.$emit('objCreacion', obj);
    if (this.edicion) this.$emit('objEdicion', obj);
  }
}
